/**
 * @module store/modules/service
 * @description 서비스 설정 및 상담 내용 관리 Vuex 모듈
 * 서비스 타입(H/일반), SweetTracker 택배 API 설정,
 * 상담에서 수리 접수로 이어지는 상담 내용 임시 저장을 담당합니다.
 */
import Cookies from 'js-cookie'

export default {
  // ============================================================
  // State
  // ============================================================
  state: () => ({
    serviceType: Cookies.get('serviceType') ? Cookies.get('serviceType') : 'H',
    sweetTrackerApiKey: 'k2BE89zqHNM8e1dtkRKYnw',
    sweetTrackerDeliveryCompanyUrl: 'https://info.sweettracker.co.kr/api/v1/companylist',
    sweetTrackerTrackingUrl: 'https://info.sweettracker.co.kr/tracking/5',
    consultationContent: {
      partnerId: '',
      consultationId: '',
      contact: '',
      customerType: '',
      customerName: '',
      customerId: '',
      serialNumber: '',
      productLineId: '',
      productLineName: '',
      repairRequestMainTypeCode: ''
    }
  }),
  // ============================================================
  // Getters
  // ============================================================
  getters: {
    /** @returns {string} 현재 서비스 타입 코드 */
    serviceType: (state) => state.serviceType,
    /** @returns {object} 현재 임시 저장된 상담 내용 */
    getConsultationContent: (state) => state.consultationContent
  },
  // ============================================================
  // Mutations
  // ============================================================
  mutations: {
    /**
     * 서비스 타입을 변경하고 쿠키에 저장합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {string} type - 서비스 타입 코드
     */
    setServiceType(state, type) {
      state.serviceType = type
    },
    /**
     * 상담 내용을 새 객체로 불변 업데이트합니다.
     *
     * @param {object} state - Vuex 상태 객체
     * @param {object} data - 저장할 상담 내용 데이터
     */
    setConsultationContent(state, data) {
      state.consultationContent = { ...data }
    }
  },
  // ============================================================
  // Actions
  // ============================================================
  actions: {
    /**
     * 서비스 타입을 커밋합니다.
     *
     * @param {object} context - Vuex 액션 컨텍스트
     * @param {string} type - 설정할 서비스 타입 코드
     */
    setServiceType({ commit }, type) {
      commit('setServiceType', type)
    },
    /**
     * 상담 내용을 커밋합니다.
     *
     * @param {object} context - Vuex 액션 컨텍스트
     * @param {object} data - 저장할 상담 내용 데이터
     */
    updateConsultationContent({ commit }, data) {
      commit('setConsultationContent', data)
    }
  }
}
